/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type DeSmartconexVertragsgeneratorWorkflowsCreatorv1QueryVariables = {
    collectionId: string;
};
export type DeSmartconexVertragsgeneratorWorkflowsCreatorv1QueryResponse = {
    readonly node: {
        readonly name?: string;
        readonly items?: {
            readonly edges: ReadonlyArray<{
                readonly cursor: string | null;
                readonly node: {
                    readonly id: string;
                    readonly __typename: "DocumentTemplate";
                    readonly title?: string;
                    readonly description?: string | null;
                    readonly color?: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
};
export type DeSmartconexVertragsgeneratorWorkflowsCreatorv1Query = {
    readonly response: DeSmartconexVertragsgeneratorWorkflowsCreatorv1QueryResponse;
    readonly variables: DeSmartconexVertragsgeneratorWorkflowsCreatorv1QueryVariables;
};



/*
query DeSmartconexVertragsgeneratorWorkflowsCreatorv1Query(
  $collectionId: ID!
) {
  node(id: $collectionId) {
    __typename
    ... on Collection {
      name
      items(first: 100) {
        edges {
          cursor
          node {
            __typename
            id
            ... on DocumentTemplate {
              __typename
              id
              title
              description
              color
            }
          }
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collectionId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "collectionId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "DeSmartconexVertragsgeneratorWorkflowsCreatorv1Query",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "CollectionItemConnection",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CollectionItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/)
                                                            ],
                                                            "type": "DocumentTemplate",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "items(first:100)"
                                }
                            ],
                            "type": "Collection",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "DeSmartconexVertragsgeneratorWorkflowsCreatorv1Query",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "CollectionItemConnection",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CollectionItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v5 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/)
                                                            ],
                                                            "type": "DocumentTemplate",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "items(first:100)"
                                }
                            ],
                            "type": "Collection",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "d0581a1bad090a94ca1649709c6ec098",
            "id": null,
            "metadata": {},
            "name": "DeSmartconexVertragsgeneratorWorkflowsCreatorv1Query",
            "operationKind": "query",
            "text": "query DeSmartconexVertragsgeneratorWorkflowsCreatorv1Query(\n  $collectionId: ID!\n) {\n  node(id: $collectionId) {\n    __typename\n    ... on Collection {\n      name\n      items(first: 100) {\n        edges {\n          cursor\n          node {\n            __typename\n            id\n            ... on DocumentTemplate {\n              __typename\n              id\n              title\n              description\n              color\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '171241a57a129d76512e62cb477369e4';
export default node;
